/**
 * @ComponentFor Avensia.Shop.Features.Search.Pages.Search.SearchPage
 */
import React from "react";
function SearchPage(props) {
    return (React.createElement("div", null, "SearchPage"));
}
export default SearchPage;
